import { useRefreshOnPortalMessage } from './useRefreshOnPortalMessage';

/**
 * Runs `refresh` when the AcombaGO host tells us its side panel came back on screen.
 *
 * Reducing the panel (the "−", not the "×") only hides it behind a CSS class: the iframe keeps running,
 * so nothing remounts and `useRefreshOnVisible` never fires either — `visibilitychange` tracks the
 * browser tab, and the tab stayed visible the whole time. Without this signal a panel reduced for hours
 * would come back showing whatever it last loaded. Closing the panel instead tears the iframe down, so
 * that path already reloads on its own.
 */
export const useRefreshOnPanelRestored = (refresh: () => void): void => {
    useRefreshOnPortalMessage('portal:panel-restored', refresh);
};
